<template>
  <app-layout class="alliances-template">
    <Affix :offset-top="60">
      <Card shadow v-if="alliances.data.careplan && alliances.data.careplan.length > 10" :padding="10" :style="{borderRadius: '0'}">
        <div class="ivu-input-wrapper ivu-input-type">
          <i class="ivu-icon ivu-icon-search ivu-input-icon ivu-input-icon-normal"></i>
          <input autocomplete="off" v-model="keyword" @keyup.13="searchGroup(keyword)" spellcheck="false" type="text" placeholder="Search..."
            class="ivu-input">
        </div>
      </Card>
    </Affix>
    <Row type="flex" justify="center">
      <!-- <Col :span="24">
        <div class="search-box">
          <div class="ivu-input-wrapper ivu-input-type" style="position:relative">
            <input autocomplete="off" style="padding-left:15px" v-model="keyword" v-on:keyup.enter="search(keyword)" :disabled="alliances.isLoading" spellcheck="false" type="text" :placeholder="'Search...'" class="ivu-input">
            <span v-if="keyword" style="position: absolute;z-index: 2;top: 9px;right: 13px;" @click="clear()"><a>View All</a></span>
          </div>
        </div>
      </Col> -->
      <Col :span="24" v-if="userInfo.user_type === 'member'">
        <Card :padding="5" style="margin:5px 15px;position:relative">
          <router-link tag="p" to="/create-organization" align="center">Register Organization</router-link>
        </Card>
      </Col>
      <Col v-if="alliances.data" :span="24" v-for="(item,k) in alliances.data.careplan" :key="k">
        <Card shadow :style="{borderRadius: '0', borderTop: '1px solid #F2F2F2'}" :padding="15">
          <router-link tag="div" :to="'/resources/' + item.id + '?tab=posts'">
            <!-- <Icon type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
            <Avatar shape="square" :src="item.thumbnail_photo[0].medium"></Avatar>&nbsp;&nbsp;{{item.title}}
            <span style="float:right;color:#2d8cf0;vertical-align:middle;margin-right:10px;font-size: 20px" v-if="userInfo.user_type !== 'guest' && item.subscribed">
            <i class="fas fa-check-circle"></i></span>
          </router-link>
        </Card>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
  export default {
    name: 'AlliancesComponent',
    data() {
      return {
        keyword: null
      }
    },
    mounted() {
      this.clear();
    },
    computed: {
      userInfo: {
        get() { return this.$store.state.user.info }
      },
      alliances: {
        get() { return this.$store.state.alliance.alliances }
      }
    },
    methods:{
      clear() {
        this.keyword = null
        this.$store.dispatch('alliance/getAlliances', {keyword: null})
      },
      search(v) {
        this.$store.dispatch('alliance/getAlliances', {keyword:v})
      }
    }
  }
</script>
